import { Menu, MenuItem } from "@fluentui/web-components";
import { LitElement, html, css } from "lit";
import { customElement, property, query, state } from "lit/decorators.js"
import { downSvg } from "src/modules/svg/svgIcons";

@customElement("display-select")
export class DisplaySelect extends LitElement {
  static styles = [
    css`
      :host {
        display: block;
      }

      .anchor-button {
        anchor-name: --anchor-el;
      }

      .menu {
        position-anchor: --anchor-el;
        top: anchor(bottom);
        margin: 0;
        justify-self: anchor-center;
        position-area: right span-bottom;
        border: 0;
        padding: 10px 50px 50px;
        background-color: transparent;
    }
    `
  ];

  @state() iconSlotName?:string = "default";

  @query("#menu") menu!:Menu & { hidePopover:()=> void, togglePopover:()=> void }

  buttonClickHandler =  (e: Event)=>{
    this.menu.togglePopover();
  }

  menuClickHandler = (e:Event) =>{
    const targetMenuItem =(e.target as HTMLElement).closest("fluent-menu-item") as MenuItem;
      var iconSlot = `${targetMenuItem.id}-icon`;
      this.iconSlotName =iconSlot;
      this.close()
  } 

  close = () => this.menu.hidePopover();

  render() {
    return html`
          <fluent-button class="anchor-button" id="measure-button" @click=${this.buttonClickHandler}>
            <div style="display:flex">
              <slot name="${this.iconSlotName}"></slot>
              ${downSvg(24)}
            </div>
          </fluent-button>
    
          <div id="menu" class="menu" popover>
            <fluent-menu style="max-width:none;width:max-content" @click=${this.menuClickHandler}>
              <slot name="menu-item"></slot>
            </fluent-menu>          
          </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "display-select": DisplaySelect;
  }
}
